import React from 'react'
import {
    useMultiStyleConfig,
    Flex,
    Divider,
} from '@salesforce/retail-react-app/app/components/shared/ui'

const LineCosmetic = () => {
    const styles = useMultiStyleConfig('Footer', {})

    return (
        <Flex {...styles.lineCosmeticContainer}>
            {Array.from({length: 5}, (_, index) => (
                <Divider key={index} orientation="horizontal" {...styles.lineCosmeticIcon} />
            ))}
        </Flex>
    )
}

export default LineCosmetic
